import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { FeatureUpdateNotificationService } from '@h5s/feature-update-notification';

/**
 * Guardia che impedisce la navigazione (sia `CanActivate` che `CanActivateChild`)
 * se la dialog di aggiornamento obbligatorio della PWA è attualmente visibile.
 *
 * Questo previene l'utente dal navigare verso altre sezioni dell'applicazione
 * quando è richiesto un aggiornamento forzato, garantendo che l'unica azione
 * possibile sia ricaricare la pagina per applicare la nuova versione.
 */
export const updateRequiredGuard: CanActivateFn | CanActivateChildFn = () => {
  const featureUpdateService = inject(FeatureUpdateNotificationService);

  return !featureUpdateService.updateIsRequired();
};
